import Image from 'components/Common/Image'
import React, { useCallback, useMemo } from 'react'
import * as Analytics from 'analytics/analytics'
import { tourExploreOperator } from 'analytics/snowplow/events'
import qs from 'qs'
import Places from 'constants/places'
import styled from 'styled-components'
import Clickable from 'components/Common/Clickable'
import { rem } from 'polished'

const OperatorLogoContainer = styled(Clickable)`
  display: flex;
  align-items: center;
  height: 100%;
  flex-shrink: 0;
  border-radius: ${props => props.theme.borderRadius.S};
  border: 1px solid ${props => props.theme.palette.neutral.six};
  padding: ${rem(12)};
`

interface Props {
  operator: Tours.TourOperator
}

function TourOperatorTile(props: Props) {
  const { operator } = props

  const operatorSearchUrl = useMemo(() => {
    const { code } = operator
    const queryString = qs.stringify({
      operators: [code],
      destinationId: Places.Anywhere.id,
      destinationName: Places.Anywhere.name,
    }, {
      arrayFormat: 'comma',
    })
    return `/search/tours?${queryString}`
  }, [operator])

  const onOperatorClick = useCallback(() => {
    Analytics.track('tour-event', tourExploreOperator(operator.name.toLowerCase()))
  }, [operator])

  return (
    <OperatorLogoContainer
      onClick={onOperatorClick}
      key={operator.name}
      to={operatorSearchUrl}
    >
      <Image
        id={operator.imageId}
        quality="eco"
        width={150}
        alt={operator.name}
        aria-hidden="true"
        dpr={2}
      />
    </OperatorLogoContainer>
  )
}

export default TourOperatorTile
